import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from '@/contexts/AuthContext';
import Router from '@/router';
import '@/styles/main.scss';
import 'antd/dist/reset.css';
import 'virtual:uno.css';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);

root.render(
  <ConfigProvider locale={zhCN}>
    <HashRouter>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </HashRouter>
  </ConfigProvider>,
);
